'use client';

import { useAuthData, useAuthToken } from '@/store/auth';
import { AccountProvider } from '../account-provider';
import { BeforeProvider } from '../before-provider';
import { SyncProvider } from '../sync-provider';
import { AuthProvider } from '../auth-provider';
import { OneDomainProvider } from '../one-domain-provider';
import { GTMProvider } from '../gtm-providers';
import { AppearanceProvider } from '../appearance-provider';
import { KafkaProvider } from '../kafka-provider';
import { NextAnalyseCleaner, NextAnalyseProvider, useIsNextAnalyseEnabled } from '@/features/next-analyse';
import { WindowProvider } from '../window-provider';
import { CDNMonitorProvider } from '../cdn-monitor-provider/cdn-monitor-provider';
import { SentryProvider } from '../sentry-provider';
import { OpenObserveProvider } from '../openobserve-provider';
import { useDeeplinkCompleteTracking } from '@/hooks/use-deeplink-complete-tracking';

export const SiteProviders = () => {
	const authToken = useAuthToken();
	const { isRedisTokenChecked } = useAuthData() ?? {};
	const isNextAnalyseEnabled = useIsNextAnalyseEnabled();
	
	// 追踪 Deeplink 登入到目标页面载入的完整时间
	useDeeplinkCompleteTracking();

	return (
		<>
			<AppearanceProvider />
			<AuthProvider />
			<OneDomainProvider />
			{isRedisTokenChecked && authToken ? <AccountProvider /> : <BeforeProvider />}
			<SyncProvider authToken={authToken} />
			<GTMProvider />
			<KafkaProvider />
			<CDNMonitorProvider />
			<SentryProvider />
			<OpenObserveProvider />
			{
				isNextAnalyseEnabled ? <NextAnalyseProvider /> : <NextAnalyseCleaner />
			}
			<WindowProvider />
		</>
	);
};